import { Component, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { toSignal } from '@angular/core/rxjs-interop';
import { MainNavComponent } from '../main-nav/main-nav.component';
import { LoginButtonComponent } from '../login-button/login-button.component';
import { SignupButtonComponent } from '../signup-button/signup-button.component';
import { LogoutButtonComponent } from '../logout-button/logout-button.component';

@Component({
  selector: 'bodyanalytics-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  imports: [MainNavComponent, LoginButtonComponent, SignupButtonComponent, LogoutButtonComponent],
})
export class NavComponent {
  private readonly auth = inject(AuthService);

  /**
   * `true` until Auth0's startup session check resolves (silent-auth on a hard
   * reload / fresh navigation), then reflects the SDK's live loading state.
   * Auth0's `isAuthenticated$` doesn't emit its first value until `isLoading$`
   * goes false, so an unresolved `isAuth()` (`undefined`) must NOT be treated
   * as "signed out" — that's what caused an authenticated visitor to see a
   * flash (or persistent showing) of Login/Sign-up after a hard reload (#1939).
   * Defaults to `true` so nothing renders before the SDK's first emission.
   */
  isLoading = toSignal(this.auth.isLoading$, { initialValue: true });
  isAuth = toSignal(this.auth.isAuthenticated$);
}
